import type { SVGProps } from "react";
const SenecPictogramFast = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M25 4H30V2H18V4H23V4.02456C12.4189 4.5456 4 13.2896 4 24C4 28.2623 5.33444 32.2159 7.6083 35.462C7.92516 35.9143 8.54873 36.0242 9.00108 35.7073C9.45342 35.3904 9.56325 34.7669 9.24639 34.3145C7.20043 31.3938 6 27.8386 6 24C6 14.0589 14.0589 6 24 6C33.9411 6 42 14.0589 42 24C42 33.9411 33.9411 42 24 42C19.7208 42 15.7927 40.508 12.7038 38.0149C12.274 37.6681 11.6444 37.7353 11.2975 38.1651C10.9507 38.5948 11.0179 39.2244 11.4477 39.5713C14.8794 42.341 19.2473 44 24 44C35.0457 44 44 35.0457 44 24C44 18.8369 42.0436 14.1308 38.8317 10.5826L39 10.4142L40.7929 12.2071L42.2071 10.7929L37.2071 5.79289L35.7929 7.20711L37.5858 9L37.4174 9.16834C34.0996 6.16501 29.7695 4.25942 25 4.02456V4Z"
            fill="currentColor"
        />
        <path
            d="M25 9C25 8.44772 24.5523 8 24 8C23.4477 8 23 8.44772 23 9V14C23 14.5523 23.4477 15 24 15C24.5523 15 25 14.5523 25 14V9Z"
            fill="currentColor"
        />
        <path
            d="M32.366 11.5098C32.6422 11.0315 32.4783 10.4199 32 10.1437C31.5217 9.8676 30.9101 10.0315 30.634 10.5098L28.134 14.8399C27.8578 15.3182 28.0217 15.9298 28.5 16.2059C28.9783 16.4821 29.5899 16.3182 29.866 15.8399L32.366 11.5098Z"
            fill="currentColor"
        />
        <path
            d="M39 25H34C33.4477 25 33 24.5523 33 24C33 23.4477 33.4477 23 34 23H39C39.5523 23 40 23.4477 40 24C40 24.5523 39.5523 25 39 25Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27C25.6569 27 27 25.6569 27 24C27 23.8127 26.9828 23.6293 26.95 23.4515L37.4902 17.366C37.9685 17.0899 38.1324 16.4783 37.8563 16C37.5801 15.5217 36.9685 15.3578 36.4902 15.634L25.9495 21.7197C25.4252 21.271 24.7442 21 24 21ZM23 24C23 23.4477 23.4477 23 24 23C24.5523 23 25 23.4477 25 24C25 24.5523 24.5523 25 24 25C23.4477 25 23 24.5523 23 24Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramFast;
